import classNames from 'classnames';

import styles from '../MobileCard.module.scss';

import { Indicators, IndicatorStyles } from '../MobileCard';

export function Indicator(indicator: Indicators): React.ReactElement<any> {
    return (
        <div
            className={classNames([
                styles.status,
                styles.indicator,
                indicator === Indicators.Task && IndicatorStyles.Task,
            ])}
        />
    );
}
